import { countries } from '@/data/Countries';

export interface IpLocation {
    country: string;
    city: string;
}

export const locationService = {
    async current(signal: AbortSignal): Promise<IpLocation> {
        const response = await fetch('https://weather.velocorner.com/location/ip', {
            signal,
            credentials: 'omit',
        });
        if (!response.ok) throw new Error('Location lookup failed');
        const location: unknown = await response.json();
        if (!location || typeof location !== 'object') throw new Error('Invalid location response');
        const { country, city } = location as Record<string, unknown>;
        const code = typeof country === 'string' ? country.trim().toUpperCase() : '';
        if (!Object.prototype.hasOwnProperty.call(countries, code)) throw new Error('Unknown location country');
        return { country: code, city: typeof city === 'string' ? city.trim() : '' };
    },
};
